import { render, staticRenderFns } from "./FaultEvent.vue?vue&type=template&id=bb666834&scoped=true"
import script from "./FaultEvent.vue?vue&type=script&lang=js"
export * from "./FaultEvent.vue?vue&type=script&lang=js"
import style0 from "./FaultEvent.vue?vue&type=style&index=0&id=bb666834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb666834",
  null
  
)

export default component.exports